var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.1 35.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e50012;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.1,28.68c0,3.98-3.24,7.22-7.22,7.22H7.23c-3.99,0-7.23-3.24-7.23-7.22V7.23C0,3.24,3.24,0,7.23,0h93.65c3.99,0,7.22,3.24,7.22,7.23v21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.72,19.58c1.25.49,1.88,1.67,2.3,3.41.47,1.95.99,4.37,1.34,5.08h-4.28c-.24-.52-.7-2.14-1.1-4.28-.4-2.21-1.03-2.8-2.42-2.8h-.8v7.07h-4.11V10.16c1.27-.21,3.03-.38,4.91-.38,2.42,0,7.17.26,7.17,5.24,0,2.14-1.34,3.81-3.01,4.46v.09ZM46.84,17.94c1.74,0,2.75-1.08,2.75-2.56,0-2.07-1.53-2.47-2.49-2.47-.66,0-1.1.05-1.34.12v4.91h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.11,28.07h-11.4v-2.58l2.07-2.23c3.08-3.22,4.93-5.31,4.93-7.47,0-1.36-.82-2.49-2.54-2.49-1.2,0-2.37.61-3.2,1.2l-1.08-3.01c1.1-.8,3.05-1.53,5.1-1.53,4.02,0,5.83,2.47,5.83,5.45s-2.07,5.57-4.25,7.73l-1.5,1.43v.05h6.04v3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.03,18.48c1.95.47,3.52,2.07,3.52,4.42,0,3.01-2.49,5.43-6.72,5.43-1.95,0-3.66-.47-4.58-1.03l.87-3.12c.68.42,2.09.92,3.36.92,1.83,0,2.87-1.06,2.87-2.4,0-1.79-1.6-2.58-3.31-2.58h-1.17v-2.89h1.06c1.32,0,2.94-.64,2.94-2.14,0-1.08-.77-1.86-2.26-1.86-1.15,0-2.3.47-2.98.87l-.8-2.96c.94-.59,2.84-1.18,4.79-1.18,3.52,0,5.4,2.02,5.4,4.42,0,1.83-1.1,3.31-2.98,4.07v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.69,14.28h-6.9c-.04.21-.21.34-.61.42v2.38l.48-.55c1.96.99,4.93,2.61,6.36,3.81l-2.08,2.55c-.99-.95-2.97-2.25-4.76-3.31v8.55h-2.99v-13.85h-6.67v-2.8h17.16v2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.92,
    y: 4.53,
    width: 26.84,
    height: 26.84,
    rx: 3.4,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.85,21.21h-5.32v7.1h-4.54V8.82l9.52.02c2.12,0,3.77.54,4.93,1.63,1.1,1.04,1.65,2.45,1.65,4.25s-.48,3.33-1.43,4.5c-1.1,1.33-2.71,1.99-4.81,1.99M22.12,12.44h-4.59v5.23h4.47c.84,0,1.51-.25,1.99-.75.49-.5.73-1.21.73-2.14,0-1.56-.87-2.33-2.6-2.33"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP8);
export default __webpack_public_path__ + "static/media/p8.9cf7919c54ee8d9c404b5699177be5e1.svg";
export { ForwardRef as ReactComponent };